import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainPage from "./pages/MainPage";
import ContactUs from "./cmponants/ContactUs";
import ServiceDetails from "./cmponants/ServiceDetails";
import Potfolio from "./cmponants/Potfolio";
import ScrollToTop from "./cmponants/ScrollToTop";
import './App.css'


export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/potfolio" element={<Potfolio />} />
        <Route path="/cardDetails" element={<ServiceDetails />} />
      </Routes>
    </BrowserRouter>
  );
}
